import { useState, useEffect, useCallback } from "react";
import { api } from "../api";
import { useAuth } from "../AuthContext";

const IVA = 0.22;

function fmt(n) { return Number(n || 0).toFixed(2).replace(".", ",") + " €"; }

function calcolaTotali(imponibile, tipoCliente, scontoPct = 0) {
  const scontoAmt = imponibile * (scontoPct / 100);
  const imp = imponibile - scontoAmt;
  if (tipoCliente === "DOM") {
    return { subtotale: imponibile, sconto_amt: scontoAmt, imponibile: imp, iva: 0, totale: imp, totale_da_pagare: imp, regime: "iva_inclusa", label_iva: "IVA inclusa" };
  }
  const iva = imp * IVA;
  if (tipoCliente === "PA") {
    return { subtotale: imponibile, sconto_amt: scontoAmt, imponibile: imp, iva, totale: imp + iva, totale_da_pagare: imp, regime: "split_payment", label_iva: "IVA 22% SP" };
  }
  return { subtotale: imponibile, sconto_amt: scontoAmt, imponibile: imp, iva, totale: imp + iva, totale_da_pagare: imp + iva, regime: "iva_standard", label_iva: "IVA 22%" };
}

// ── Step indicator ────────────────────────────────────────────────────────────
function StepBar({ steps, current }) {
  return (
    <div className="steps-bar" style={{ overflowX: "auto", paddingBottom: 4 }}>
      {steps.map((s, i) => (
        <div key={i} className={`step ${current === i ? "active" : ""} ${current > i ? "done" : ""}`}>
          <div className="step-circle">{current > i ? "✓" : i + 1}</div>
          <div className="step-label">{s}</div>
          {i < steps.length - 1 && <div className="step-line" />}
        </div>
      ))}
    </div>
  );
}

// ── Step servizi per categoria ────────────────────────────────────────────────
function StepServizi({ categoria, tipoCliente, vociSel, onToggle, promoDisp }) {
  const isBene = (s) => s.tipo_prodotto === "bene";

  return (
    <div>
      {categoria.descrizione && (
        <div style={{ background: "#f0f5ff", border: "1px solid #dbeafe", borderRadius: 8, padding: "10px 14px", marginBottom: 16, fontSize: 12, color: "#1d4ed8" }}>
          ℹ️ {categoria.descrizione}
        </div>
      )}

      {categoria.servizi.length === 0 && (
        <div style={{ textAlign: "center", padding: "32px", color: "#94a3b8", fontSize: 13 }}>
          Nessun servizio disponibile per questo tipo cliente
        </div>
      )}

      {categoria.servizi.map(s => {
        const voce = vociSel[s.id];
        const sel = !!voce;
        const promo = promoDisp?.find(p => {
          const ids = p.servizi_ids ? (Array.isArray(p.servizi_ids) ? p.servizi_ids : JSON.parse(p.servizi_ids)) : [];
          return !ids.length || ids.includes(s.id);
        });

        return (
          <div key={s.id} style={{ border: `1.5px solid ${sel ? "#93c5fd" : "#e2e8f0"}`, borderRadius: 10, marginBottom: 10, overflow: "hidden", background: sel ? "#eff6ff" : "white" }}>

            {/* Riga principale */}
            <div style={{ display: "flex", alignItems: "center", padding: "12px 14px", cursor: "pointer", gap: 10 }}
              onClick={() => onToggle(s, "toggle")}>
              <div style={{ width: 20, height: 20, borderRadius: 4, border: sel ? "none" : "2px solid #cbd5e1", background: sel ? "#0f2850" : "transparent", display: "flex", alignItems: "center", justifyContent: "center", color: "white", fontSize: 12, flexShrink: 0 }}>
                {sel ? "✓" : ""}
              </div>
              <div style={{ flex: 1 }}>
                <div style={{ fontSize: 13, fontWeight: 600 }}>{s.nome_override || s.nome}</div>
                {s.descrizione && <div style={{ fontSize: 11, color: "#64748b" }}>{s.descrizione}</div>}
                {promo && <div style={{ fontSize: 10, color: "#15803d", marginTop: 2 }}>🎁 {promo.nome} disponibile</div>}
              </div>
              <div style={{ textAlign: "right", flexShrink: 0 }}>
                {s.prezzo_mensile > 0 && <div style={{ fontSize: 13, fontWeight: 700, color: "#0f2850" }}>{fmt(s.prezzo_mensile)}<span style={{ fontSize: 10, color: "#94a3b8" }}>/mese</span></div>}
                {s.prezzo_attivazione > 0 && <div style={{ fontSize: 11, color: "#64748b" }}>Att: {fmt(s.prezzo_attivazione)}</div>}
                {isBene(s) && s.prezzo_vendita > 0 && <div style={{ fontSize: 11, color: "#64748b" }}>Vendita: {fmt(s.prezzo_vendita)}</div>}
              </div>
            </div>

            {/* Opzioni se selezionato */}
            {sel && (
              <div style={{ borderTop: "1px solid #dbeafe", padding: "12px 14px", background: "#f8faff" }}>
                <div style={{ display: "flex", flexWrap: "wrap", gap: 12, alignItems: "flex-end" }}>

                  {/* Quantità */}
                  <div>
                    <div style={{ fontSize: 10, fontWeight: 700, color: "#64748b", marginBottom: 4 }}>QUANTITÀ</div>
                    <div style={{ display: "flex", alignItems: "center", gap: 6 }}>
                      <button onClick={() => onToggle(s, "qty", Math.max(1, (voce.qty || 1) - 1))}
                        style={{ width: 24, height: 24, borderRadius: 6, border: "1px solid #e2e8f0", background: "white", cursor: "pointer", fontWeight: 700 }}>−</button>
                      <span style={{ minWidth: 20, textAlign: "center", fontWeight: 700 }}>{voce.qty || 1}</span>
                      <button onClick={() => onToggle(s, "qty", (voce.qty || 1) + 1)}
                        style={{ width: 24, height: 24, borderRadius: 6, border: "1px solid #e2e8f0", background: "white", cursor: "pointer", fontWeight: 700 }}>+</button>
                    </div>
                  </div>

                  {/* Attivazione */}
                  {s.prezzo_attivazione > 0 && (
                    <label style={{ display: "flex", alignItems: "center", gap: 6, fontSize: 12, cursor: "pointer" }}>
                      <input type="checkbox" checked={!!voce.includi_attivazione}
                        onChange={e => onToggle(s, "attivazione", e.target.checked)} />
                      Includi attivazione ({fmt(s.prezzo_attivazione)})
                    </label>
                  )}

                  {/* Modalità bene: vendita o noleggio */}
                  {isBene(s) && (
                    <div>
                      <div style={{ fontSize: 10, fontWeight: 700, color: "#64748b", marginBottom: 4 }}>MODALITÀ</div>
                      <div style={{ display: "flex", gap: 6 }}>
                        {["vendita", "noleggio", "entrambi"].map(m => (
                          <button key={m} className={`chip ${voce.modalita === m ? "active" : ""}`}
                            style={{ fontSize: 11, padding: "4px 10px" }}
                            onClick={() => onToggle(s, "modalita", m)}>
                            {m === "vendita" ? "Vendita" : m === "noleggio" ? "Noleggio" : "Entrambi"}
                          </button>
                        ))}
                      </div>
                    </div>
                  )}

                  {/* Promo */}
                  {promo && (
                    <label style={{ display: "flex", alignItems: "center", gap: 6, fontSize: 12, cursor: "pointer" }}>
                      <input type="checkbox" checked={!!voce.promo_id}
                        onChange={e => onToggle(s, "promo", e.target.checked ? promo : null)} />
                      🎁 Applica "{promo.nome}"
                    </label>
                  )}
                </div>
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
}

// ── Componente principale ─────────────────────────────────────────────────────
export default function NuovoPreventivo({ onSalvato }) {
  const { utente } = useAuth();
  const [step, setStep]             = useState(0);
  const [tipoCliente, setTipoCliente] = useState(null);
  const [cliente, setCliente]       = useState({ ragione_sociale:"",piva:"",codice_fiscale:"",indirizzo:"",cap:"",citta:"",email:"",telefono:"",referente:"",codice_sdi:"",pec:"" });
  const [durata, setDurata]         = useState("12 mesi");
  const [note, setNote]             = useState("");
  const [sconto, setSconto]         = useState(0);
  const [vociSel, setVociSel]       = useState({});
  const [categorie, setCategorie]   = useState([]);
  const [promoDisp, setPromoDisp]   = useState([]);
  const [saving, setSaving]         = useState(false);
  const [errore, setErrore]         = useState(null);
  const [risultato, setRisultato]   = useState(null);
  const [suggerimentiCliente, setSuggerimentiCliente] = useState([]);

  const DURATE = ["1 mese","3 mesi","6 mesi","12 mesi","24 mesi","36 mesi"];

  // Carica catalogo quando tipo cliente è selezionato
  useEffect(() => {
    if (!tipoCliente) return;
    api.getServiziWizard(tipoCliente).then(setCategorie).catch(console.error);
    // Carica tutte le promo attive per questo tipo cliente
    api.getPromoDisponibili(tipoCliente, []).then(setPromoDisp).catch(console.error);
  }, [tipoCliente]);

  // Aggiorna promo quando cambiano le voci selezionate
  useEffect(() => {
    if (!tipoCliente) return;
    const ids = Object.keys(vociSel).map(Number);
    api.getPromoDisponibili(tipoCliente, ids).then(setPromoDisp).catch(console.error);
  }, [vociSel, tipoCliente]);

  // Autocompletamento cliente
  const cercaCliente = useCallback(async (q) => {
    if (q.length < 2) { setSuggerimentiCliente([]); return; }
    try {
      const res = await api.cercaClienti(q, tipoCliente);
      setSuggerimentiCliente(res);
    } catch { setSuggerimentiCliente([]); }
  }, [tipoCliente]);

  const selezionaCliente = (c) => {
    setCliente({
      ragione_sociale: c.ragione_sociale, piva: c.piva || "",
      codice_fiscale: c.codice_fiscale || "", indirizzo: c.indirizzo || "",
      cap: c.cap || "", citta: c.citta || "", email: c.email || "",
      telefono: c.telefono || "", referente: c.referente || "",
      codice_sdi: c.codice_sdi || "", pec: c.pec || "",
    });
    setSuggerimentiCliente([]);
  };

  const handleToggle = (servizio, azione, valore) => {
    setVociSel(prev => {
      const next = { ...prev };
      if (azione === "toggle") {
        if (next[servizio.id]) { delete next[servizio.id]; return next; }
        next[servizio.id] = {
          id: servizio.id, nome: servizio.nome_override || servizio.nome,
          prezzo_base: servizio.prezzo_mensile || servizio.prezzo_vendita || 0,
          prezzo_attivazione: servizio.prezzo_attivazione || 0,
          prezzo_vendita: servizio.prezzo_vendita || 0,
          prezzo_noleggio: servizio.prezzo_noleggio || 0,
          prezzo_riscatto: servizio.prezzo_riscatto || 0,
          durata_noleggio_mesi: servizio.durata_noleggio_mesi || 24,
          unita: servizio.unita, tipo_prodotto: servizio.tipo_prodotto,
          qty: 1, modalita: "vendita",
          includi_attivazione: false, promo_id: null,
        };
      } else if (azione === "qty") {
        if (next[servizio.id]) next[servizio.id] = { ...next[servizio.id], qty: valore };
      } else if (azione === "attivazione") {
        if (next[servizio.id]) next[servizio.id] = { ...next[servizio.id], includi_attivazione: valore };
      } else if (azione === "modalita") {
        if (next[servizio.id]) next[servizio.id] = { ...next[servizio.id], modalita: valore };
      } else if (azione === "promo") {
        if (next[servizio.id]) next[servizio.id] = { ...next[servizio.id], promo_id: valore?.id || null, promo_nome: valore?.nome || null };
      }
      return next;
    });
  };

  // Calcolo totali
  const tutteLeVoci = Object.values(vociSel);
  const imponibileBase = tutteLeVoci.reduce((acc, v) => {
    let p = v.prezzo_base * v.qty;
    if (v.includi_attivazione) p += v.prezzo_attivazione * v.qty;
    return acc + p;
  }, 0);
  const totali = calcolaTotali(imponibileBase, tipoCliente, sconto);

  // Steps dinamici
  const stepsLabels = ["Tipo cliente", "Dati cliente", ...categorie.map(c => c.label_step), "Riepilogo"];
  const stepIdx = step;
  const isCatStep = step >= 2 && step < 2 + categorie.length;
  const catIdx = isCatStep ? step - 2 : -1;

  const salva = async () => {
    setSaving(true); setErrore(null);
    try {
      const vociPayload = tutteLeVoci.map(v => ({
        id: v.id, nome: v.nome,
        prezzo: v.prezzo_base, prezzo_base: v.prezzo_base,
        prezzo_attivazione: v.includi_attivazione ? v.prezzo_attivazione : 0,
        prezzo_vendita: v.prezzo_vendita,
        prezzo_noleggio: v.prezzo_noleggio,
        prezzo_riscatto: v.prezzo_riscatto,
        durata_noleggio_mesi: v.durata_noleggio_mesi,
        unita: v.unita, tipo_prodotto: v.tipo_prodotto,
        modalita: v.modalita, qty: v.qty,
        promo_id: v.promo_id || null,
        categoria: categorie.find(c => c.servizi.some(s => s.id === v.id))?.nome || "Altro",
      }));

      const promoApplicate = tutteLeVoci.filter(v => v.promo_id).map(v => ({ servizio_id: v.id, promo_id: v.promo_id, promo_nome: v.promo_nome }));

      const res = await api.crea({
        tipo_cliente: tipoCliente,
        ...cliente,
        durata, sconto_pct: sconto, note,
        voci: vociPayload,
        promo_applicate: promoApplicate,
      });
      setRisultato(res);
    } catch (e) { setErrore(e.message); }
    setSaving(false);
  };

  const reset = () => {
    setStep(0); setTipoCliente(null);
    setCliente({ ragione_sociale:"",piva:"",codice_fiscale:"",indirizzo:"",cap:"",citta:"",email:"",telefono:"",referente:"",codice_sdi:"",pec:"" });
    setVociSel({}); setCategorie([]); setRisultato(null);
    setSconto(0); setNote(""); setErrore(null);
  };

  // Schermata successo
  if (risultato) return (
    <div className="success-screen">
      <div className="success-card">
        <div className="success-icon">✅</div>
        <h2>Preventivo salvato!</h2>
        <div className="success-proto">{risultato.protocollo}</div>
        <div className="success-totale">{fmt(risultato.totale_da_pagare)}</div>
        <div style={{ fontSize: 11, color: "#94a3b8", marginBottom: 20 }}>
          {tipoCliente === "PA" ? "Totale da pagare (split payment)" : tipoCliente === "DOM" ? "IVA inclusa" : "IVA esclusa"}
        </div>
        <div className="success-actions">
          <button className="btn btn-primary" onClick={() => api.downloadPdf(risultato.id, risultato.protocollo).catch(e => alert(e.message))}>⬇️ Scarica PDF</button>
          <button className="btn btn-ghost" onClick={reset}>Nuovo preventivo</button>
          <button className="btn btn-ghost" onClick={onSalvato}>Vai all'archivio</button>
        </div>
      </div>
    </div>
  );

  return (
    <div className="page">
      <div className="page-header">
        <h1>Nuovo preventivo</h1>
        {tipoCliente && <span className="tipo-badge" style={{
          background: tipoCliente === "DOM" ? "#f0fdf4" : tipoCliente === "AZ" ? "#f0f5ff" : "#fff5f5",
          color: tipoCliente === "DOM" ? "#0f7c4a" : tipoCliente === "AZ" ? "#0f2850" : "#6b1a1a"
        }}>{tipoCliente === "DOM" ? "Domestico" : tipoCliente === "AZ" ? "Aziendale" : "Pubblica Amministrazione"}</span>}
      </div>

      <StepBar steps={stepsLabels} current={stepIdx} />

      <div className="card">

        {/* ── Step 0: Tipo cliente ────────────────────────────────────── */}
        {step === 0 && (
          <>
            <h2 className="card-title">Seleziona tipologia cliente</h2>
            <div className="tipo-grid">
              {[
                { key: "DOM", label: "Domestico", color: "#0f7c4a", bg: "#f0fdf4", desc: "Privati e famiglie — prezzi IVA inclusa" },
                { key: "AZ",  label: "Aziendale",  color: "#0f2850", bg: "#f0f5ff", desc: "PMI e professionisti — prezzi IVA esclusa" },
                { key: "PA",  label: "Pubblica Amm.", color: "#6b1a1a", bg: "#fff5f5", desc: "Enti PA — split payment IVA 22% SP" },
              ].map(t => (
                <button key={t.key} className={`tipo-card ${tipoCliente === t.key ? `selected-${t.key.toLowerCase()}` : ""}`}
                  style={{ "--tipo-color": t.color, "--tipo-bg": t.bg }}
                  onClick={() => setTipoCliente(t.key)}>
                  <div className="tipo-card-label">{t.label}</div>
                  <div className="tipo-card-short">{t.key}</div>
                  <div style={{ fontSize: 10, color: t.color, opacity: 0.7, marginTop: 6 }}>{t.desc}</div>
                </button>
              ))}
            </div>
            <div className="step-actions">
              <div />
              <button className="btn btn-primary" disabled={!tipoCliente} onClick={() => setStep(1)}>Avanti →</button>
            </div>
          </>
        )}

        {/* ── Step 1: Dati cliente ────────────────────────────────────── */}
        {step === 1 && (
          <>
            <h2 className="card-title">Dati cliente</h2>

            {/* Autocompletamento */}
            <div style={{ position: "relative", marginBottom: 16 }}>
              <label className="form-label">Cerca cliente esistente</label>
              <input className="form-input" placeholder="Digita ragione sociale o P.IVA..."
                onChange={e => { setCliente({...cliente, ragione_sociale: e.target.value}); cercaCliente(e.target.value); }}
                value={cliente.ragione_sociale} />
              {suggerimentiCliente.length > 0 && (
                <div style={{ position: "absolute", top: "100%", left: 0, right: 0, background: "white", border: "1.5px solid #e2e8f0", borderRadius: 8, zIndex: 100, boxShadow: "0 4px 12px rgba(0,0,0,0.1)" }}>
                  {suggerimentiCliente.map(c => (
                    <div key={c.id} onClick={() => selezionaCliente(c)} style={{ padding: "10px 14px", cursor: "pointer", borderBottom: "1px solid #f1f5f9", fontSize: 13 }}>
                      <div style={{ fontWeight: 600 }}>{c.ragione_sociale}</div>
                      <div style={{ fontSize: 11, color: "#94a3b8" }}>{c.piva} · {c.citta}</div>
                    </div>
                  ))}
                </div>
              )}
            </div>

            <div className="form-grid">
              <div className="form-group">
                <label className="form-label">P.IVA</label>
                <input className="form-input" value={cliente.piva} onChange={e => setCliente({...cliente, piva: e.target.value})} />
              </div>
              <div className="form-group">
                <label className="form-label">Codice Fiscale</label>
                <input className="form-input" value={cliente.codice_fiscale} onChange={e => setCliente({...cliente, codice_fiscale: e.target.value})} />
              </div>
              <div className="form-group span-2">
                <label className="form-label">Indirizzo</label>
                <input className="form-input" value={cliente.indirizzo} onChange={e => setCliente({...cliente, indirizzo: e.target.value})} />
              </div>
              <div className="form-group">
                <label className="form-label">CAP</label>
                <input className="form-input" value={cliente.cap} onChange={e => setCliente({...cliente, cap: e.target.value})} />
              </div>
              <div className="form-group">
                <label className="form-label">Città</label>
                <input className="form-input" value={cliente.citta} onChange={e => setCliente({...cliente, citta: e.target.value})} />
              </div>
              <div className="form-group">
                <label className="form-label">Email</label>
                <input className="form-input" type="email" value={cliente.email} onChange={e => setCliente({...cliente, email: e.target.value})} />
              </div>
              <div className="form-group">
                <label className="form-label">Telefono</label>
                <input className="form-input" value={cliente.telefono} onChange={e => setCliente({...cliente, telefono: e.target.value})} />
              </div>
              <div className="form-group">
                <label className="form-label">Referente</label>
                <input className="form-input" value={cliente.referente} onChange={e => setCliente({...cliente, referente: e.target.value})} />
              </div>
              {(tipoCliente === "AZ" || tipoCliente === "PA") && (<>
                <div className="form-group">
                  <label className="form-label">PEC</label>
                  <input className="form-input" value={cliente.pec} onChange={e => setCliente({...cliente, pec: e.target.value})} />
                </div>
                <div className="form-group">
                  <label className="form-label">Codice SDI</label>
                  <input className="form-input" value={cliente.codice_sdi} onChange={e => setCliente({...cliente, codice_sdi: e.target.value})} />
                </div>
              </>)}
            </div>

            <div style={{ marginTop: 16 }}>
              <label className="form-label">Durata contratto</label>
              <div className="chip-group">
                {DURATE.map(d => <button key={d} className={`chip ${durata === d ? "active" : ""}`} onClick={() => setDurata(d)}>{d}</button>)}
              </div>
            </div>

            <div className="step-actions">
              <button className="btn btn-ghost" onClick={() => setStep(0)}>← Indietro</button>
              <button className="btn btn-primary" disabled={!cliente.ragione_sociale.trim()} onClick={() => setStep(2)}>Avanti →</button>
            </div>
          </>
        )}

        {/* ── Step categorie servizi ─────────────────────────────────── */}
        {isCatStep && categorie[catIdx] && (
          <>
            <h2 className="card-title">{categorie[catIdx].icona} {categorie[catIdx].nome}</h2>
            <StepServizi
              categoria={categorie[catIdx]}
              tipoCliente={tipoCliente}
              vociSel={vociSel}
              onToggle={handleToggle}
              promoDisp={promoDisp} />
            <div className="step-actions">
              <button className="btn btn-ghost" onClick={() => setStep(step - 1)}>← Indietro</button>
              <button className="btn btn-primary" onClick={() => setStep(step + 1)}>Avanti →</button>
            </div>
          </>
        )}

        {/* ── Step riepilogo ─────────────────────────────────────────── */}
        {step === 2 + categorie.length && (
          <>
            <h2 className="card-title">Riepilogo preventivo</h2>

            <div style={{ borderLeft: "4px solid #0f2850", borderRadius: 8, padding: "14px 16px", marginBottom: 20, background: "#f8faff" }}>
              <div style={{ fontSize: 16, fontWeight: 800, color: "#0f2850" }}>{cliente.ragione_sociale}</div>
              <div style={{ fontSize: 12, color: "#64748b", marginTop: 2 }}>{[cliente.email, cliente.telefono].filter(Boolean).join(" · ")} · {durata}</div>
            </div>

            {tutteLeVoci.length === 0 && (
              <div style={{ textAlign: "center", padding: 32, color: "#94a3b8" }}>
                Nessun servizio selezionato — torna indietro e aggiungi almeno un servizio
              </div>
            )}

            {tutteLeVoci.length > 0 && (
              <table className="riepilogo-table">
                <thead>
                  <tr style={{ background: "#0f2850" }}>
                    <th>Servizio</th><th>Modalità</th><th>Q.tà</th><th style={{ textAlign: "right" }}>P.U.</th><th style={{ textAlign: "right" }}>Totale</th>
                  </tr>
                </thead>
                <tbody>
                  {tutteLeVoci.flatMap((v, i) => {
                    const rows = [];
                    const modalita = v.tipo_prodotto === "bene" ? v.modalita : v.unita === "mese" ? "Canone/mese" : "Una tantum";
                    // Riga canone/prezzo base
                    rows.push(
                      <tr key={v.id + "_base"} className={i % 2 === 0 ? "row-even" : "row-odd"}>
                        <td>
                          {v.nome}
                          {v.promo_nome && <span style={{ fontSize: 9, background: "#f0fdf4", color: "#15803d", padding: "1px 5px", borderRadius: 4, marginLeft: 6 }}>🎁 {v.promo_nome}</span>}
                        </td>
                        <td style={{ fontSize: 11, color: "#64748b" }}>{modalita}</td>
                        <td style={{ textAlign: "center" }}>{v.qty}</td>
                        <td style={{ textAlign: "right" }}>{fmt(v.prezzo_base)}</td>
                        <td style={{ textAlign: "right", fontWeight: 700 }}>{fmt(v.prezzo_base * v.qty)}</td>
                      </tr>
                    );
                    // Riga attivazione separata
                    if (v.includi_attivazione && v.prezzo_attivazione > 0) {
                      rows.push(
                        <tr key={v.id + "_att"} className={i % 2 === 0 ? "row-even" : "row-odd"}>
                          <td style={{ paddingLeft: 20, color: "#64748b" }}>↳ Attivazione {v.nome}</td>
                          <td style={{ fontSize: 11, color: "#64748b" }}>Una tantum</td>
                          <td style={{ textAlign: "center" }}>{v.qty}</td>
                          <td style={{ textAlign: "right" }}>{fmt(v.prezzo_attivazione)}</td>
                          <td style={{ textAlign: "right", fontWeight: 700 }}>{fmt(v.prezzo_attivazione * v.qty)}</td>
                        </tr>
                      );
                    }
                    return rows;
                  })}
                </tbody>
              </table>
            )}

            {/* Sconto e note */}
            <div className="form-grid" style={{ marginBottom: 16 }}>
              <div className="form-group">
                <label className="form-label">Sconto aggiuntivo (%)</label>
                <input className="form-input" type="number" min="0" max="100" value={sconto}
                  onChange={e => setSconto(Math.min(100, Math.max(0, +e.target.value)))} style={{ maxWidth: 120 }} />
              </div>
            </div>
            <div className="form-group" style={{ marginBottom: 20 }}>
              <label className="form-label">Note / Condizioni</label>
              <textarea className="form-input" rows={3} value={note} onChange={e => setNote(e.target.value)}
                placeholder="Es. Attivazione inclusa per contratti ≥24 mesi" />
            </div>

            {/* Riepilogo fiscale per tipo cliente */}
            <div style={{ maxWidth: 320, marginLeft: "auto", marginBottom: 20 }}>
              <div className="tot-row"><span>Subtotale</span><span>{fmt(totali.subtotale)}</span></div>
              {sconto > 0 && <div className="tot-row sconto"><span>Sconto {sconto}%</span><span>- {fmt(totali.sconto_amt)}</span></div>}
              <div className="tot-row"><span>Imponibile</span><span>{fmt(totali.imponibile)}</span></div>

              {tipoCliente === "DOM" ? (
                <div className="tot-row" style={{ color: "#94a3b8", fontSize: 11 }}><span>IVA inclusa nel prezzo</span><span>—</span></div>
              ) : (
                <div className="tot-row"><span>{totali.label_iva}</span><span>{fmt(totali.iva)}</span></div>
              )}

              <div className="tot-finale" style={{ background: "#0f2850" }}>
                <span>{tipoCliente === "PA" ? "Totale (IVA non incassata)" : "TOTALE"}</span>
                <span>{fmt(totali.totale)}</span>
              </div>

              {tipoCliente === "PA" && (
                <div style={{ background: "#fef3c7", borderRadius: 8, padding: "8px 12px", marginTop: 8, fontSize: 11, color: "#92400e" }}>
                  ⚠️ Split payment: totale da pagare <strong>{fmt(totali.totale_da_pagare)}</strong> — la PA versa l'IVA direttamente all'erario
                </div>
              )}
              {tipoCliente === "DOM" && (
                <div style={{ background: "#f0fdf4", borderRadius: 8, padding: "8px 12px", marginTop: 8, fontSize: 11, color: "#15803d" }}>
                  ✅ Prezzi IVA inclusa — totale da pagare <strong>{fmt(totali.totale_da_pagare)}</strong>
                </div>
              )}
            </div>

            {errore && <div className="errore-box">⚠️ {errore}</div>}

            <div className="step-actions">
              <button className="btn btn-ghost" onClick={() => setStep(step - 1)}>← Modifica</button>
              <button className="btn btn-primary" onClick={salva} disabled={saving || tutteLeVoci.length === 0}>
                {saving ? "⏳ Salvataggio..." : "💾 Salva e genera PDF"}
              </button>
            </div>
          </>
        )}
      </div>
    </div>
  );
}
